//import { InspectionRoutes } from '@linkdev/inspection-library';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomepageComponent } from './homepage/homepage.component';
import { PostActivationComponent } from './post-activation/post-activation.component';
import { SearchComponent } from './search/search.component';
import { SettingsMenuComponent } from './header-footer/header/components/settings-menu/settings-menu.component';
import { HandleLogin } from './handleLogin/handle-login.component';
import { ServiceManagementRoutes } from '@linkdev/service-management-library';
import { AccessManagementRoutes } from '@linkdev/access-manage-library';
import { LookupsRoutes } from '@linkdev/lookup-library';
import { ErrorPageComponent } from './shared/components/error-page/error-page.component';
//import { OnlinePaymentStatusComponent } from '@linkdev/portals-shared';
import { ServiceListComponent } from './service-list/service-list.component';
import { ServiceDetailsComponent } from './service-details/service-details.component';
import { ActivationSuccessfullyComponent } from './activation-successfully/activation-successfully.component';
import { TokenExpiredComponent } from './token-expired/token-expired.component';
import { ServiceHostComponent,ReviewRequestComponent, RequestSuccessComponent } from '@linkdev/ssa-shared';
import { GuardService } from '@linkdev/shared-library';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomepageComponent,
  },
  {
    path: `${ServiceManagementRoutes.baseRoute}/${ServiceManagementRoutes.serviceCardsRoute}`,
    component: ServiceListComponent,
    // loadChildren: () =>
    //   import('./portal-services-library/portal-services.module').then(
    //     (m) => m.PortalServicesModule
    //   ),
  },
  {
    path: `${ServiceManagementRoutes.baseRoute}/${ServiceManagementRoutes.serviceDetailsRoute}/:serviceKey`,
    component: ServiceDetailsComponent,
  },
  {
    path: `${ServiceManagementRoutes.baseRoute}/${ServiceManagementRoutes.serviceDetailsRoute}/:serviceKey/:isBlank`,
    component: ServiceDetailsComponent,
  },

  {
    path: `${ServiceManagementRoutes.baseRoute}/${ServiceManagementRoutes.applyRequestRoute}/:serviceKey`,
    component:ServiceHostComponent,
    canDeactivate: [GuardService],
    runGuardsAndResolvers: 'always'
  },
  {
    path: `${ServiceManagementRoutes.baseRoute}/${ServiceManagementRoutes.viewRequestRoute}/:serviceKey`,
    component: ReviewRequestComponent,
    canDeactivate: [GuardService]
},
{
    path: `${ServiceManagementRoutes.baseRoute}/${ServiceManagementRoutes.viewTaskRoute}/:serviceKey`,
    component: ReviewRequestComponent,
    canDeactivate: [GuardService]
},

  {
    path: `${AccessManagementRoutes.baseRoute}`,
    loadChildren: () =>
      import('./portal-profile-library/portal-profile.module').then(
        m => m.PortalProfileModule
      )
  },
  // {
  //   path: `${InspectionRoutes.baseRoute}`,
  //   loadChildren: () =>
  //     import('./portal-inspection-library/portal-inspection-library.module')      .then(
  //       m => m.PortalInspectionLibraryModule),
  //   data: { logo: '../assets/images/logo-inspection.png' }
  // },
  {
    path: 'postactivation',
    component: PostActivationComponent,
  },
  {
    path: 'activationsuccessfully',
    component: ActivationSuccessfullyComponent,
  },
  {
    path: `${LookupsRoutes.publicBaseRoute}`,
    loadChildren: () =>
      import('./portal-lookup-library/portal-lookup-library.module').then(
        m => m.PortalLookupLibraryModule
      )
  },
  {
    path: 'notifications',
    loadChildren: () => import('./portal-notifications-library/portal-notifications-library.module')
      .then(m => m.PortalNotificationsLibraryModule)
  },
  {
    path: 'settings-menu',
    component: SettingsMenuComponent,
  },
  {
    path: 'search',
    component: SearchComponent,
  },
  {
    path: 'handlelogin',
    component: HandleLogin,
  },
  {
    path: 'error',
    component: ErrorPageComponent,

  },
  {
    path: 'tokenexpired',
    component: TokenExpiredComponent,
  },
  {
    path: 'notifications',
    loadChildren: () => import('./portal-ssa-library/portal-shared-module-library.module')
      .then(m => m.PortalSharedModuleLibraryModule)
  },
  {
    path:'',
    loadChildren: () => import('./portal-ssa-library/portal-common-services-library.module')
    .then(m => m.PortalSSACommonServicesLibraryModule)

  
  },
  {
    path: `request/success/:requestId`,
    component: RequestSuccessComponent,
    }
  ,
  
  /*{
    path: 'onlinePaymentStatus',
    component: OnlinePaymentStatusComponent,
  }*/
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
